<script setup lang="ts">
import { ref } from 'vue';
import { useStore } from '@/store';
import { useRouter } from 'vue-router';

const store = useStore();
const router = useRouter();
const username = ref('');
const password = ref('');
const error = ref('')

const login = async () => {
  try {
    error.value = '';
    const success = await store.login(username.value, password.value);
    if(success){
      const isAdmin = await store.user?.admin || false;
      router.push(isAdmin? '/admin' : '/');
    }else{
      error.value = 'Login Failed'
    }
  } catch (error) {
    console.error('Login failed:', error);
  }
};
</script>

<template>
  <div class="flex items-center justify-center min-h-screen">
    <div class="w-full max-w-md">
      <form @submit.prevent="login" class="bg-gray-800 shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <h2 class="text-2xl mb-6 text-center font-bold text-white">Login</h2>
        <div class="mb-4">
          <label class="block text-white text-sm font-bold mb-2" for="username">
            Username
          </label>
          <input v-model="username" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="username" type="text" placeholder="Username">
        </div>
        <div class="mb-6">
          <label class="block text-white text-sm font-bold mb-2" for="password">
            Password
          </label>
          <input v-model="password" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline" id="password" type="password" placeholder="******************">
        </div>
        <div v-if="error" class="mb-3">
          {{ error }}
        </div>
        <div class="flex items-center justify-between">
          <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="submit">
            Sign In
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
